import { Menubar as BaseMenubar } from '@base-ui/react/menubar';
import type { ComponentProps } from 'react';
import { cx } from '../lib/styled.tsx';

export type MenubarProps = ComponentProps<typeof BaseMenubar>;

/**
 * The application-style bar along the top of a window: a row of {@link Menu}
 * roots that behave as one. Once any of them is open, moving along the bar
 * opens the next without a second click.
 */
export function Menubar({ className, ...props }: MenubarProps) {
  return (
    <BaseMenubar
      className={cx(
        'flex items-center gap-1 rounded-control border border-border-subtle bg-surface p-1',
        className,
      )}
      {...props}
    />
  );
}
